<div class="content">
    <img src="{{url_image}}">
</div>